export const SET_HEADER_INFORMATION = 'SET_HEADER_INFORMATION';
export const ADD_BREADCRUMB_LINK = 'ADD_BREADCRUMB_LINK';
export const OVERWRITE_BREADCRUMB_LINKS = 'OVERWRITE_BREADCRUMB_LINKS';
export const CHANGE_RATING_VISIBILITY = 'CHANGE_RATING_VISIBILITY';
export const CHANGE_RATING = 'CHANGE_RATING';
export const CHANGE_ENTITY_LOADING = 'CHANGE_ENTITY_LOADING';
export const CHANGE_HEADER_LOADING = 'CHANGE_HEADER_LOADING';
export const CHANGE_HEADER_TAB_INDEX = 'CHANGE_HEADER_TAB_INDEX';
export const SUMMARY_REQUEST = 'SUMMARY_REQUEST';
export const CHANGE_QUESTIONS_SUMMARY = 'CHANGE_QUESTIONS_SUMMARY';
export const SUMMARY_FAILED = 'SUMMARY_FAILED';
export const CHANGE_ANSWERS_SUMMARY = 'CHANGE_ANSWERS_SUMMARY';
export const CHANGE_GRAPH_VISIBILITY = 'CHANGE_GRAPH_VISIBILITY';
export const CHANGE_PERIOD_SELECTOR_VISIBILITY = 'CHANGE_PERIOD_SELECTOR_VISIBILITY';
export const CHANGE_SELECTED_PERIOD = 'CHANGE_SELECTED_PERIOD';
